import React from 'react';

type Props = Pick<
  React.HTMLAttributes<HTMLLIElement>,
  'aria-disabled' | 'aria-selected' | 'className' | 'onClick' | 'onMouseMove' | 'onTouchStart' | 'role' | 'tabIndex'
> & { index: number };

export const AutocompleteOption: React.FC<React.PropsWithChildren<Props>> = ({
  'aria-disabled': ariaDisabled,
  'aria-selected': ariaSelected,
  children,
  className,
  index,
  onClick,
  onMouseMove,
  onTouchStart,
  role,
  tabIndex,
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
  <li
    aria-disabled={ariaDisabled}
    aria-selected={ariaSelected}
    className={className}
    data-option-index={index}
    onClick={onClick}
    onMouseMove={onMouseMove}
    onTouchStart={onTouchStart}
    role={role}
    tabIndex={tabIndex}
  >
    {children}
  </li>
  /* eslint-enable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
);
